<template>
    <div class="flex-spacer"/>
</template>
<script>

export default {
}

</script>
<style scoped lang="scss">
.flex-spacer {
    padding:0.25em;
    flex:1;
}



</style>